export const TRANSLATIONS_ES ={
 "header.home" : "Hogar" ,
 "header.admin.signUp": "Inscribirse",
 "footer.contactUs": "Contacta Con Nosotras",
 "page.endDate": "Fecha final",
 "page.login": "Acceso",
 "page.email": "Correo Electrónico",
 "page.company": "Compañía",
 "page.firstName": "Nombre de pila",
 "page.lastName": "Apellido",
 "page.address1": "Dirección Línea 1",
 "page.address2": "Dirección Línea 2",
 "page.city": "Ciudad",
 "page.country": "País",
 "page.state": "Estado",
 "page.zipCode": "Código postal",
 "page.zipExt": "Extensión postal",
 "page.phone": "Teléfono",
 "page.manageMFA.token":"Se requiere ficha.",
 "page.MFAModel.header":"Proporcione un token de autenticación multifactor desde la aplicación Authenticator",
 "page.MFAModel.token":"Simbólico",
 "page.MFAModel.reset":"Restablecer autenticación multifactor",
 "page.forgotPasswd.toResetPassword":"Para restablecer la contraseña",
 "page.forgotPasswd.step1":"1. Solicitud de un código de verificación que se enviará a su dirección de correo electrónico.",
 "page.forgotPasswd.step2":"2. Ingrese el código de verificación recibido junto con la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.step1.1":"Paso 1. Proporcione la identificación de correo electrónico registrada para generar un código de verificación.",
 "page.forgotPasswd.step1.2":"Verifique su correo electrónico para obtener el código de verificación después de enviar la solicitud.",
 "page.forgotPasswd.step2.1":"Paso 2. Ingrese el código de verificación enviado por correo electrónico y la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.verificationCode":"Código de verificación",
 "page.verification.verifyAccount":"Verifica tu cuenta",
 "page.verification.checkEmail":"Por favor revise su correo electrónico registrado para el código de verificación.",
 "page.resendCode.resend":"Vuelva a enviar el código de verificación",
 "page.login.forgotPassword":"Has olvidado tu contraseña",
 "page.submit": "Enviar",
 "page.cancel": "Cancelar",
 "page.password": "Clave",
 "page.confirmationMessage": "Estas seguro?",
 
 "error.MFATokenError": "Error!! El token de autenticación multifactor proporcionado no es válido.",
 "error.getCountryFailed":"Error!! No se recuperó la lista de países",
 "error.getCountryAnswersFailed":"Error!! No se recuperaron las respuestas del país",
 "error.getFoodGroupFailed":"Error!! no se recuperaron los grupos de alimentos",
 "error.getFoodFailed":"Error!! La lista de alimentos no se recuperó",
 "error.getFoodAnswersFailed":"Error!! Los detalles de los alimentos no se recuperaron",
 "error.changePasswordFailed":"Error!! Cambio de contraseña falló. Por favor, inténtelo de nuevo más tarde",
 "error.error":"Error!!",
 "error.userAuthFailed":"Autenticación de usuario fallida.",
 "error.emailReqd":"Correo electronico es requerido.",
 "error.invalidEmail":"Proporcione una identificación de correo electrónico válida!",
 "error.passwdReqd":"Se requiere contraseña.",
 "error.weakPassword":"Elija una contraseña segura con un mínimo de 8 caracteres, un número y un carácter especial!",
 "error.passwdMatchFailed":"Las contraseñas no coinciden!",
 "error.MFAAuthFailed": "Error!! La autenticación multifactor falló ",
 "error.MFAStateError": "Error!! Hubo un error al cambiar el estado de MFA.",
 "error.termsUpdateFailed": "Error!! Actualización de términos y condiciones fallida.",
 "error.retypePasswdReqd":"Se requiere volver a escribir la contraseña!",
 "error.sendCodeError":"Error!! Error al enviar el código de verificación para restablecer la contraseña. Por favor, inténtelo de nuevo más tarde",
 "error.codeReqd":"Se necesita un código de verificación!",
 "error.verificationFailed":"Error!! Fallo en la verificación. Por favor, inténtelo de nuevo más tarde",
 "error.resendVerificationFailed":"Error!! Error al reenviar el código de verificación. Por favor, inténtelo de nuevo más tarde",
 "error.userNameReqd":"Se requiere nombre de usuario.",
 "error.firstNameReqd":"Se requiere el primer nombre.",
 "error.lastNameReqd":"Se requiere apellido.",
 "error.compNameReqd":"Se requiere el nombre de la empresa.",
 "error.stateReqd":"Se requiere estado.",
 "error.userEditFailed":"Error!! La información del cliente no se actualizó",
 "error.addUserFailed":"Agregar usuario fallido.",
 "error.getStateFailed":"Error!! No se recuperó la lista de estados",
 "error.phoneReqd":"Se requiere teléfono.",
 "error.sessionTimeout":"Se ha agotado el tiempo de sesión. Por favor inicie sesión nuevamente.",
 "error.getTermsFailed":"El término no fue recuperado.",
 "error.logoutFailed":"Error al cerrar sesión.",
}